import { createClient as createWSClient } from 'graphql-ws';
import { GRAPHQL_HOST } from 'config';

const wsClient = createWSClient({ url: `${GRAPHQL_HOST.replace(/http(s?):\/\//, 'ws$1://')}/graphql` });

export default wsClient;
